import { useEffect, useState } from 'react';
import useSarasStore from '../hooks/localDB/useSarasStore';
import { formatUnicorn } from '../../helper/uiFunctions';

const SarasLogTrans = (props) => {
    const { value, transObject } = props;
    const [localeValue, setLocaleValue] = useState(value || '');
    const localDb = useSarasStore();

    useEffect(() => {
        setLocaleValue(value || '');
    }, [value, transObject]);

    useEffect(() => {
        let isActive = true;

        const requestString = (key, fallbackValue) => {
            return new Promise((resolve) => {
                if (!key || typeof key !== "string") {
                    resolve(fallbackValue || '');
                    return;
                }

                localDb.requestString(key, (requestKey, transValue) => {
                    resolve(transValue || fallbackValue || requestKey || '');
                });
            });
        };

        const translateValue = async () => {
            if (!transObject) {
                return;
            }

            try {
                const localeObject = JSON.parse(transObject);

                if (!localeObject || !localeObject.messageKey) {
                    return;
                }

                const translatedTemplate = await requestString(localeObject.messageKey, value || localeObject.messageKey);
                const sourceParams = Array.isArray(localeObject.formatterParams) ? localeObject.formatterParams : [];
                const translatedParams = await Promise.all(sourceParams.map((param) => requestString(param, param)));

                if (!isActive) {
                    return;
                }

                setLocaleValue(formatUnicorn(translatedTemplate, translatedParams) || value || '');
            }
            catch {
                if (isActive) {
                    setLocaleValue(value || '');
                }
            }
        };

        translateValue();

        return () => {
            isActive = false;
        };
    }, [localDb, transObject, value]);

    return localeValue || '';
}

export default SarasLogTrans;
